import dayjs from 'dayjs';

export interface ResidentContact {
  id: string;
  name: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastMessageTime?: dayjs.Dayjs;
  unreadCount?: number;
}

export interface ChatMessage {
  id: string;
  senderId: 'currentUser' | string;
  recipientId: string;
  text: string;
  timestamp: dayjs.Dayjs;
  isRead?: boolean;
}

export const residentContacts: ResidentContact[] = [
  {
    id: 'res1',
    name: 'Elena Rodriguez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/60.jpg',
    lastMessage: 'Ok, vou verificar isso. Obrigada!',
    lastMessageTime: dayjs().subtract(15, 'minute'),
    unreadCount: 2,
  },
  {
    id: 'res2',
    name: 'Carlos Gomez',
    avatarUrl: 'https://randomuser.me/api/portraits/men/45.jpg',
    lastMessage: 'Você pode reenviar o documento?',
    lastMessageTime: dayjs().subtract(1, 'hour'),
  },
  {
    id: 'res3',
    name: 'Sofia Fernandez',
    avatarUrl: 'https://randomuser.me/api/portraits/women/33.jpg',
    lastMessage: 'Perfeito, nos vemos então.',
    lastMessageTime: dayjs().subtract(3, 'hour'),
    unreadCount: 0,
  },
  {
    id: 'res4',
    name: 'Luis Hernandez',
    lastMessage: 'Pagamento confirmado.',
    lastMessageTime: dayjs().subtract(1, 'day'),
  },
];

export const chatHistory: Record<string, ChatMessage[]> = {
  res1: [
    { id: 'msg1', senderId: 'res1', recipientId: 'currentUser', text: 'Olá, tenho uma pergunta sobre meu último pagamento.', timestamp: dayjs().subtract(1, 'hour'), isRead: true },
    { id: 'msg2', senderId: 'currentUser', recipientId: 'res1', text: 'Oi Elena, claro, qual é sua pergunta?', timestamp: dayjs().subtract(55, 'minute'), isRead: true },
    { id: 'msg3', senderId: 'res1', recipientId: 'currentUser', text: 'Pensei que paguei por 2 meses, mas o aplicativo só mostra 1.', timestamp: dayjs().subtract(30, 'minute'), isRead: true },
    { id: 'msg4', senderId: 'currentUser', recipientId: 'res1', text: 'Deixe-me verificar isso para você. Um momento por favor.', timestamp: dayjs().subtract(25, 'minute'), isRead: true },
    { id: 'msg5', senderId: 'currentUser', recipientId: 'res1', text: 'Ok, vejo o problema. Foi um pequeno problema do sistema, deve estar atualizado agora. Por favor atualize seu aplicativo.', timestamp: dayjs().subtract(18, 'minute'), isRead: false },
    { id: 'msg6', senderId: 'res1', recipientId: 'currentUser', text: 'Ok, vou verificar isso. Obrigada!', timestamp: dayjs().subtract(15, 'minute'), isRead: false },
  ],
  res2: [
    { id: 'msg7', senderId: 'res2', recipientId: 'currentUser', text: 'Bom dia, preciso de uma cópia do documento de diretrizes da comunidade.', timestamp: dayjs().subtract(2, 'hour') },
    { id: 'msg8', senderId: 'currentUser', recipientId: 'res2', text: 'Oi Carlos, anexei a este mensagem.', timestamp: dayjs().subtract(1, 'hour').add(5, 'minute') },
    { id: 'msg9', senderId: 'res2', recipientId: 'currentUser', text: 'Você pode reenviar o documento?', timestamp: dayjs().subtract(1, 'hour') },
  ],
  res3: [
    { id: 'msg10', senderId: 'res3', recipientId: 'currentUser', text: 'Oi, a casa club está disponível para reserva no sábado?', timestamp: dayjs().subtract(5, 'hour') },
  ]
};
